import { render, staticRenderFns } from "./UsersAssignerDialog.vue?vue&type=template&id=e823776c"
import script from "./UsersAssignerDialog.vue?vue&type=script&lang=ts"
export * from "./UsersAssignerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports